/**
 * Lil Legends — Disable Enter key on search, keep predictive search intact
 */
(function () {
  function disableSearchEnter() {
    // Target all search inputs across desktop, mobile, drawer, modal
    const searchForms = document.querySelectorAll(
      'predictive-search form, search-form form, .search-modal form, .search-drawer form, form[action="/search"]'
    );

    searchForms.forEach(function (form) {
      // Prevent form submit entirely
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, true); // capture phase — fires before Shopify's own listeners

      // Also block Enter key on the input itself
      const input = form.querySelector('input[type="search"], input[name="q"]');
      if (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }, true);
      }
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableSearchEnter);
  } else {
    disableSearchEnter();
  }

  // Re-run when search modal/drawer opens dynamically
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          const forms = node.querySelectorAll
            ? node.querySelectorAll('form[action="/search"]')
            : [];
          if (forms.length > 0 || (node.tagName && node.matches('form[action="/search"]'))) {
            disableSearchEnter();
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
